import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from "prop-types";
import "../../../styles/dateTimePicker.scss";

const DatePickerViews = ({handleChange,value, minDate=null, maxDate=null ,shouldDisableMonth}) => {
    // const [date, setDate] = React.useState(dayjs(value?value:new Date().getTime()));
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']} sx={{padding: "0px"}}>
        <DatePicker 
          className={"datePicker"}
          onChange={(newValue) => {
              handleChange(newValue)
          }}
          value={dayjs(value)}
          minDate={minDate}
          maxDate={maxDate}
          views={['month', 'year']} 
          shouldDisableMonth={shouldDisableMonth}
          />
      </DemoContainer>
    </LocalizationProvider>
  );
}

DatePickerViews.propTypes = {
    handleChange:PropTypes.func,
    value:PropTypes.string,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    shouldDisableMonth:PropTypes.bool
}

export default DatePickerViews;